import axios from '@/util/request';

export function GetList(parameter) {
  //资料管理-项目信息列表
  return axios({
    url: '/ims/verifyOrder/page',
    method: 'post',
    data: parameter,
  })
}

export function GetOne(id) {
  return axios({
    url: '/ims/verifyOrder/' + id,
    method: 'get',
  })
}

// 预览送检单
export function PreView(parameter) {
  return axios({
    url: '/ims/verifyOrder/PreView',
    method: 'post',
    data: parameter
  })
}
// 新增送检单
export function CreateAsync(parameter) {
  return axios({
    url: '/ims/verifyOrder',
    method: 'post',
    data: parameter
  })
}
// 修改送检单
export function Update(parameter) {
  return axios({
    url: '/ims/verifyOrder',
    method: 'put',
    data: parameter
  })
}

// 送检
export function sendOrder(parameter) {
  return axios({
    url: '/ims/verifyOrder/sendOrder',
    method: 'get',
    data: parameter
  })
}
// 删除明细
export function DeleteDetail(parameter) {
  return axios({
    url: '/ims/verifyOrder/deleteDetail',
    method: 'get',
    params: parameter
  })
}
// 撤销明细
export function RevokeDetail(parameter) {
  return axios({
    url: '/ims/verifyOrder/revokeDetail',
    method: 'post',
    params: parameter
  })
}
// 删除送检单
export function Delete(id) {
  return axios({
    url: '/ims/verifyOrder/' + id,
    method: 'delete'
  })
}
// 撤销送检单
export function Revoke(parameter) {
  return axios({
    url: '/ims/verifyOrder/revoke',
    method: 'post',
    params: parameter
  })
}
// 确认合格
export function Qualified(parameter) {
  return axios({
    url: '/ims/verifyOrder/qualified',
    method: 'post',
    params: parameter
  })
}
// 降级使用
export function Demotion(parameter) {
  return axios({
    url: '/ims/verifyOrder/demotion',
    method: 'post',
    data: parameter
  })
}
// 停用
export function Scrap(parameter) {
  return axios({
    url: '/ims/verifyOrder/scrap',
    method: 'post',
    params: parameter
  })
}

export function GetInstrument(id) {
  //获取单个仪器数据
  return axios({
    url: '/ims/instrument/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/VertifyOrder.js